import { render } from "./recovery.vue?vue&type=template&id=1e858004&ts=true"
import script from "./recovery.vue?vue&type=script&lang=ts"
export * from "./recovery.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__